import hljs from 'highlight.js';
window.up.compiler('.js-post', () => {
    hljs.highlightAll();
});
